import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import Guide from './pages/Guide'
import Tools from './pages/Tools'
import Videos from './pages/Videos'
import Downloads from './pages/Downloads'
import Activators from './pages/Activators'
import PEtools from './pages/PEtools'
import USBRecommend from './pages/USBRecommend'
import MacOSSoftware from './pages/MacOSSoftware'
import WindowsSoftware from './pages/WindowsSoftware'
import ComputerRecommend from './pages/ComputerRecommend'
import About from './pages/About'

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-2 pb-16">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/guide/:id" element={<Guide />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/activators" element={<Activators />} />
          <Route path="/petools" element={<PEtools />} />
          <Route path="/faq" element={<Guide />} />
          <Route path="/flowchart" element={<Guide />} />
          <Route path="/usb-recommend" element={<USBRecommend />} />
          <Route path="/macos-software" element={<MacOSSoftware />} />
          <Route path="/windows-software" element={<WindowsSoftware />} />
          <Route path="/computer-recommend" element={<ComputerRecommend />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}

export default App 